import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Modal from 'components/Tvendo/Common/ModalBase';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { wsGetAll } from 'services/WService';

export default function ModalWarehouse(props) {
  const warehouse = props.model;

  const [dataChanging, setDataChanging] = useState(warehouse);

  const [zones, setZones] = useState([]);

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  function handleChange(field, value) {
    setDataChanging({
      ...dataChanging,
      [field]: value
    });
  }

  useEffect(() => {
    if (warehouse.open) {
      listZones();
    }
  }, [warehouse.open]);

  return (
    <Modal
      title="Almacén"
      model={warehouse}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      dataChanging={dataChanging}
      setDataChanging={setDataChanging}
      entity="logi/warehouse"
      state
    >
      <TextField
        label="Código"
        type="text"
        name="WhsCode"
        margin="normal"
        fullWidth
        defaultValue={!!warehouse ? warehouse.WhsCode : ''}
        required
      />
      <TextField
        label="Nombre"
        type="text"
        name="WhsName"
        margin="normal"
        fullWidth
        defaultValue={!!warehouse ? warehouse.WhsName : ''}
        required
      />
      <FormControl fullWidth margin="normal" size="small">
        <InputLabel>Tipo Almacén</InputLabel>
        <Select
          defaultValue={!!warehouse ? warehouse.warehouse_type || 'N' : ''}
          inputProps={{
            name: 'warehouse_type'
          }}
          style={{ textAlign: 'left' }}
        >
          <MenuItem value="N">Normal</MenuItem>
          <MenuItem value="M">Malogrado</MenuItem>
        </Select>
      </FormControl>
      {zones.length > 0 ? (
        <Autocomplete
          options={zones}
          getOptionLabel={(option) => option.description}
          defaultValue={
            !!warehouse ? zones.find((item) => item.id == warehouse.base_zone_id) : undefined
          }
          renderInput={(params) => <TextField {...params} label="Zona" margin="normal" required />}
          onChange={(e, item) => {
            if (!!item) {
              return handleChange('base_zone_id', item.id);
            }
            handleChange('base_zone_id', null);
          }}
        />
      ) : undefined}
    </Modal>
  );
}
